import { Directive, HostListener } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { _isNil } from '@core/lodash/lodash';

@Directive({
    /* eslint-disable-next-line @angular-eslint/directive-selector */
	selector: 'ag-grid-angular:not([pmsAgGridTooltipOverride])',
	standalone: false,
})
export class AgGridTooltipDirective {

	updatedMode = false;

	constructor(
		private gridComponent: AgGridAngular,
	) {
	}

	@HostListener('displayedColumnsChanged')
	onDisplayedColumnsChanged() {
		if (this.gridComponent.api.getColumns().some(column => column.isVisible() && !_isNil(column.getColDef().tooltipComponent))) {
			if (this.gridComponent.api.getGridOption('tooltipShowMode') === 'whenTruncated') {
				// force ag-grid to always show tooltips if any column has a custom tooltip because tooltipShowMode can only be set at the grid level
				this.setTooltipShowMode('standard');
				this.updatedMode = true;
			}
		} else if (this.updatedMode) {
			// revert to truncated mode if there are no custom tooltip columns
			this.setTooltipShowMode('whenTruncated');
			this.updatedMode = false;
		}
	}

	setTooltipShowMode(mode: 'standard' | 'whenTruncated') {
		// hack tooltipShowMode is marked as an initial property but can be changed if we refresh the row data
		this.gridComponent.api.setGridOption('tooltipShowMode' as any, mode);
		this.gridComponent.api.setGridOption('rowData', this.gridComponent.rowData);
	}
}
